import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog} from 'lucide-react';
import ContentMenuCard from "../ContentMenuCard";
import LoadingButton from "../../../Loading/LoadingButton";

import contentNewfolder from "../../../contentImgs/blended-learning.png";
import Snackbar from "../../../../Snackbar";
import { createNewFolder } from "../../../../store/actions/CreateContent/FolderAPI/FolderAPIs";
import Loading from "../../../Loading/Loading";
import { createNewMilestone } from "../../../../store/actions/CreateContent/OrganizeAPI/SubCoursesAPIs";
import { createNewSection } from "../../../../store/actions/CreateContent/FolderAPI/SectionAPI";
import AddmakeFreeSection from "./AddSkillSection";
import { createNewChapter } from "../../../../store/actions/CreateContent/FolderAPI/ChapterAPI";
import AddHighlightsSection from "./AddHighlightsSection";
import AddHighlightsChapter from "./AddHighlightsChapter";
import ToggleSmall from "../../../UI/ToggleSmall";
import Toggle from "../../../UI/Toggle";
const CreateChapterPopup =({sectionItem,menuOrder,sendBackItem,changeItemData,chapterItem,setNewChapterPopUp})=>{

     const dispatch = useDispatch();
     
        const [snackbarVisible, setSnackbarVisible] = useState(false);
        const [snackbarColor, setSnackbarColor] = useState("#958FDA");
        const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
      
      const showSnackbar = () => {
        setSnackbarVisible(true);
      };
     
      const hideSnackbar = () => {
        setSnackbarVisible(false);
      };

      const [chapterName ,setChapterName] =useState(chapterItem?.Name?chapterItem?.Name:"");
     
      const [chapterDescription ,setChapterDescription] =useState(chapterItem?.Description?chapterItem?.Description:"")
      const [chapterID ,setChapterID] =useState(chapterItem?.ID?chapterItem?.ID:"");
      const [chapterMenuOrder ,setChapterMenuOrder] =useState(chapterItem?.menuOrder?chapterItem?.menuOrder:menuOrder);
      const [showAddFolderEdit ,setShowAddFolderEdit] =useState(chapterItem?.ID?true:false)
       
     const [FolderLook ,setFolderLook] =useState("")
           
           
 const [chapterHighlights ,setChapterHighlights] =useState(chapterItem?.Highlights?JSON.parse(chapterItem?.Highlights):[]);
 const [chapterMakeFree ,setChapterMakeFree] =useState(chapterItem?.makeFree?chapterItem?.makeFree:false);
            const [loader , setLoader] =useState({status:false});
      
       const [animate, setAnimate] = useState(false);
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
        



      
       const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
       const appId = useSelector((state)=>state?.app?.app?.ID);
                            const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
          
       useEffect(() => {
         // Trigger the animation after a delay (e.g., 500ms)
         const timer = setTimeout(() => {
          setAnimate(true);  
        }, 100);
      
         return () => clearTimeout(timer); // Cleanup on unmount
       }, []);
      useEffect(()=>{
        // setCourseTitleData();
      },[])
      
      
const handleCreateSection=(e)=>{

    let editType="",makeFreeData="",HighlightsData="";
    // console.log(chapterMakeFree)
      HighlightsData=JSON.stringify(chapterHighlights);
     

setLoader({status:true});
// console.log({Name:chapterName,Description:chapterDescription,makeFree:makeFreeData,
//     Highlights:HighlightsData,
//   token:AppToken,courseId:postIdCourse ,postParent:sectionItem?.ID,userEmail:user_email?user_email:null,
//   currentToken:currentToken?currentToken:null,appToken:AppToken,
//   editType:editType,postId:chapterID,menuOrder:chapterMenuOrder})
  const apiData = dispatch(createNewChapter({Name:chapterName,Description:chapterDescription,makeFree:chapterMakeFree,
    Highlights:HighlightsData,
  token:AppToken,courseId:postIdCourse ,postParent:sectionItem?.contentID,userEmail:user_email?user_email:null,
  currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,
  editType:editType,postId:chapterID,menuOrder:chapterMenuOrder}));
  /* get response as Promise   */
  apiData.then(response => {
    if(response){

    //   console.log(response)
      if(response?.chapter){
    setResponseMessage(response?.message);
    setSnackbarColor("rgba(144, 202, 249,1)");
  
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
  sendBackItem(response?.chapter);
  // console.log(response?.folder)
  setChapterID(response?.chapter?.ID);
  setChapterMenuOrder(response?.chapter?.menuOrder)
  setNewChapterPopUp(false);
},1000)
   }else{
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
   }
      
    // dispatch({
    //   type: "UPDATE_APP_TOKEN",
      
    //   payload:response?.course?.AppToken
    // });  
  //  console.log(response?.course);
 
   // 
   if(response?.logout){
    // pop up response?.logoutInfo
    //console.log(response?.logoutInfo)

    setResponseMessage("You are Logged Out!!!");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    setTimeout(()=>{
      dispatch({type:"LOGOUT"});

    },3000)
    
  }
/* resetting Login input Fields */

    }else{
      setResponseMessage("Something Went Wrong...");
      
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)    }

  }).catch(error => {
 
    //popup of error Info
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    console.error(error);
  });
 
  }
  
     
const handleUpdateSection=(val)=>{
    let editType="",makeFreeData="",HighlightsData="";
    // console.log(chapterMakeFree)
    if(val=="editChapter"){
      editType="editChapter";
      HighlightsData=JSON.stringify(chapterHighlights);
     }
  setLoader({status:true});

  console.log({Name:chapterName,Description:chapterDescription,makeFree:makeFreeData,
        Highlights:HighlightsData,
        token:AppToken,courseId:postIdCourse ,postParent:sectionItem?.ID,userEmail:user_email?user_email:null,
        currentToken:currentToken?currentToken:null,appToken:AppToken,
        editType:editType,postId:chapterID,menuOrder:chapterMenuOrder})
      const apiData = dispatch(createNewChapter({Name:chapterName,Description:chapterDescription,makeFree:chapterMakeFree,
        Highlights:HighlightsData,
      token:AppToken,courseId:postIdCourse ,postParent:sectionItem?.ID,userEmail:user_email?user_email:null,
      currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,
      editType:editType,postId:chapterID,menuOrder:chapterMenuOrder}));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){

        // console.log(response)
        if(response?.chapter){
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
changeItemData(response?.chapter?.ID,response?.chapter);
    setSnackbarVisible(false);
    setChapterDescription(response?.chapter?.Description);
    setChapterID(response?.chapter?.ID);
    setNewChapterPopUp(false);
  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }



    return (<>
    
   {/* {<Loading  Load={loader?.status}/>} */}
     {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
    {FolderLook==""?<div className="" style={{alignContent:"center",textAlign:"center",marginTop:"0px",
     
     transition: 'transform 2s ease, opacity 1s ease',
   }}> <div className="userInfoLinerName"> <h2>{!chapterID?"Create Chapter "+chapterMenuOrder+"- Add Details ":"Edit Chapter "+chapterMenuOrder+" Details" }</h2></div>
    <div align="center" className="" style={{position:"absolute", top:"70px",bottom:"98px",right:"10px",left:"10px",
            overflowY:"auto"}}>
        
        
        
    <textarea onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave} className="createContentTextbox"  style= {{fontSize:"18px",width:"85%"}} 
        placeholder="Add Chapter Name" type="text"
     rows={2} name="courseTitle" value={chapterName} onChange={
        (e)=>setChapterName(e.target.value)
    
    
     } />
     
        
    <textarea onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave} className="createContentTextbox"  style= {{fontSize:"18px",width:"85%"}} 
        placeholder="Add Chapter Details" type="text"
     rows={5} name="courseTitle" value={chapterDescription} onChange={
        (e)=>setChapterDescription(e.target.value)
    
    
     } />
 <div style={{marginLeft:"5px",width:"90%"}}className="  gridForWhatsNextAfterYT5">
  <div className="gridForFiftyFixed"><div><h4>Make This Chapter Free</h4></div>
 <Toggle state={chapterMakeFree} toggleState={(state)=>{setChapterMakeFree(state);}} /> </div>
 <div className="gridForFiftyFixed"><div><h4>Display In Course Syllabus</h4></div>
 <Toggle state={chapterMakeFree} toggleState={(state)=>{setChapterMakeFree(state);}} /> </div>
    
 </div>
    
    <div style={{width:"90%"}}>
    <AddHighlightsChapter   sendBackData={(data)=>{setChapterHighlights(data);}} data={chapterHighlights} />
    {/* <AddmakeFreeSection  sendBackData={(data)=>{setChapterMakeFree(data);}} data={chapterMakeFree}/> */}
    </div>
    
    </div>
    <div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"30px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter} 
  onMouseLeave={handleMouseLeave} onClick={()=>{setNewChapterPopUp(false)}}  
    className=" CreateCourseStepsOuterRightButtonBackPopUp"  style={{background:"#666",border:"3px solid #666",color:"#fff",fontSize:"16px"}} type="submit"
 > Cancel </button>

{chapterID?<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{
    handleUpdateSection('editChapter')
  
  }}   style={{width:"140px",height:"55px"}}
  className=" CreateCourseStepsOuterRightButtonPopUp"  type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Update"} </button>:
 <button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{
    handleCreateSection()
  
  }}  style={{width:"140px",height:"55px"}}
  className="CreateCourseStepsOuterRightButtonPopUp"  type="submit"
  id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Click To Create"}  </button>
 }
</div> 
   {/* <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
   <div  >   </div>
 
   
   <button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setopenAppDesignPopUp()}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
    id="signupBtn"> Cancel </button>
{showAddFolderEdit?
<button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{handleUpdateFolder("Description")}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
    id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Update"} </button>:
<button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateFolder()}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
    id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Click To Create"} </button>}
 </div>  */}
 
 </div>
 
 :""}
       </>)
}
export default CreateChapterPopup;

